module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BY-fcc8de152e1863e69892098acec1b1f8.png";